exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh5[data-v-46407b84] {\n    width: 550px;\n}\nbutton[data-v-46407b84] {\n    white-space: nowrap;\n}\nsmall[data-v-46407b84] {\n    font-size: xx-small;\n    letter-spacing: -1px;\n}\n.how-to[data-v-46407b84] {\n    white-space: pre-wrap;\n    background-color: rgb(215, 211, 229);\n    margin-bottom: 20px;\n    padding: 10px;\n}\n.account-recovery[data-v-46407b84] {\n    background-color: white;\n}\n", ""]);

// exports
